import { Component, HostBinding, computed } from '@angular/core';
import { AddressLabelComponent } from '../../address-label.component';

@Component({
  selector: 'residence',
  standalone: true,
  template: `
    {{ residenceName$$() }}
  `
})
export class ResidenceComponent extends AddressLabelComponent {
  @HostBinding('class.residence-label')
  residenceName$$ = computed<string>(() => this.addressFormat$$()?.residenceName);
}